const Events = require('utils/framework/Events');
const InflatorComps = require('utils/framework/InflateComponents');
const Perf = require('utils/framework/Perf');


// The Immediate event fires once all priority code is loaded but prior to any third party or api
// dependencies. Immediate should be used for components that need to potentially re-render ASAP
// based on information that is available in the initial page load but which might not be correct
// in the initial server-side render.
//
// The prime example of this is product pages, which render on the server (and cached by akamai)
// generically by product id, but which display differently depending on the skuId url parameter.
InflatorComps.services.loadEvents.ImmediateReady = true;
window.dispatchEvent(new CustomEvent(Events.ImmediateReady, { detail: {} }));
Perf.report('Immediate Ready');

InflatorComps.renderQueue(Events.Immediate);

//Analytics - This needs to run before any controllers do, so that the promise exists ahead of time
/**
 * Wait for our initial page load tag to have fired before firing any subsequent tags.
 * All subsequent async page load tags depend on the vars set in this tag.
 * Resolve: Called from Signal tag "Global :: Page-load Tracking", Additional Configuration
 */
Sephora.analytics.promises.initialPageLoadFired = new Promise(
    function (resolve, reject) {
        Sephora.analytics.resolvePromises.initialPageLoadFired = resolve;
    }
);
